<script lang="ts">
  import BrandingAdminPanel from './BrandingAdminPanel.svelte';
  import FirmasMedicosPanel from './FirmasMedicosPanel.svelte';
</script>

<section class="config">
  <h2>Marca y firmas</h2>
  <p class="hint">
    Personaliza el logo y colores de tu clínica, y carga la firma/sello de cada médico para las recetas imprimibles.
  </p>
  <BrandingAdminPanel />
  <FirmasMedicosPanel />
</section>

<style>
  .config { padding: 0; }
  h2 { margin: 0 0 0.35rem; color: var(--brand-deep); }
  .hint { color: var(--text-secondary); font-size: 0.88rem; margin: 0 0 1rem; }
</style>
